module.exports = __webpack_public_path__ + "static/media/face3ok.bf6c42fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face3ok.svg
// module id = 1219
// module chunks = 2